module.exports = __webpack_public_path__ + "media/illustrations/SignUp_Illustration-39f96867.png";